module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload"
  }, [_c('form', {
    attrs: {
      "action": _vm.uploadURL,
      "enctype": "multipart/form-data",
      "method": "post",
      "target": "upload-target"
    }
  }, [_c('input', {
    staticClass: "clickable",
    attrs: {
      "type": "file",
      "name": "file"
    }
  }), _c('br'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "upload-target"
    },
    on: {
      "load": _vm.iframeLoaded
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "clickable"
  }, [_c('span', {
    staticClass: "fa fa-fw fa-arrow-up"
  }), _vm._v(" "), _c('input', {
    staticClass: "clickable",
    attrs: {
      "type": "submit",
      "value": "Upload"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7334ffad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload.vue
// module id = 147
// module chunks = 0